import * as Html from "../../util/Html.ts";
import * as Redim from "../../lib/redim/imageRedim.ts";
import * as Medias from "../../server/Medias.ts";
import * as actionMenuRegistry from "../action-menu-registry.ts";
import * as actionMenu from "../action-menu.ts";

import Icons from "../../svg/Icons.ts";
import * as FwDatas from "../../FwDatas.ts";
import { pickFile } from "../../filer/filerModal.ts";
import { getIconFromMimeType, pickFileFromDevice } from "../../lib/FileUtils.ts"
import { addParams } from "../../lib/url.ts";
import { toastMaxAttachmentReach } from "../../util/modal.ts";

export {initDom,destroyDom}
Html.registerWidget('widget/form/input-file-menu',{initDom,destroyDom})


actionMenuRegistry.register({
  pickfilemenu(){
    const
      node = this,
      inputFile = node.querySelector('input'),
      isPremium = FwDatas.getPermission('filer')==='KO_PREMIUM',
      LIMIT = parseInt(node.getAttribute('data-limit')) || 1,
      LIMIT_FREEMIUM = parseInt(node.getAttribute('data-limit-freemium')) || 1,
      menu = [];
    //init customFiles  
    if(inputFile.customFiles===undefined) inputFile.customFiles = []
      
    const
      maxAdd = (isPremium?LIMIT_FREEMIUM:LIMIT) - inputFile.customFiles.length;

    function addFileOrMedia(... files : any[]){
      const filesLimited = files.slice(0,maxAdd);
      if(filesLimited.length<files.length) toastMaxAttachmentReach(LIMIT);
      inputFile.customFiles.push(... filesLimited);
    }
    menu.push({
      permission:(maxAdd==0 && !isPremium)? 'filer':undefined,
      svg:Icons.ic_gallery, 
      async clickFunction(){
        if(!await Medias.checkQuota()) return;
        const files = await pickFileFromDevice('image/*',maxAdd>1);
        addFileOrMedia(... files);
        inputFile.dispatchEvent(new Event("change"));
      },
      i18nkey:'actions.addpicture'
    });

    menu.push({
      permission:'filer',
      svg:Icons.filer.ic_upload,
      async clickFunction(){
        if(!await Medias.checkQuota()) return;
        const files = await pickFileFromDevice('*/*',maxAdd>1);
        addFileOrMedia(... files);
        inputFile.dispatchEvent(new Event("change"));
      },
      i18nkey:'actions.attachfile'
    })

    menu.push({
      permission:'filer',
      svg:Icons.ic_insert_file,
      async clickFunction(){
        const media = await pickFile({title:'actions.attachfilefromfiler'});
        addFileOrMedia(media);
        inputFile.dispatchEvent(new Event("change"));
      },
      i18nkey:'actions.attachfilefromfiler'
    })


    if(inputFile.customFiles.length>0){
      menu.push({svg:Icons.ic_delete,color:'var(--red)', async clickFunction(){
        inputFile.customFiles = []
        inputFile.dispatchEvent(new Event("change"));
      },i18nkey:'actions.delete'})
    }

    return {menu}
  }
})

function initDom(node: HTMLElement){
  node.setAttribute('data-key','pickfilemenu')
  actionMenu.initDom(node)

  const inputFile = node.querySelector('input') as HTMLInputElement;
  const isSimpleUI = node.getAttribute("data-ui")==="simple";
  const metaId = Html.getDomMetaId(node);
  const originalValue = FwDatas.get(metaId)?.medias || []

  if(!inputFile) return;
  inputFile.customFiles = originalValue;

  let setPreview: (value?: string) => void;

  if(isSimpleUI){
    setPreview = function(value?: string){
      node.classList.toggle("color-branded", value!==undefined)
    }
  }else{
    const commonStyle = "padding:2px;width:16px;height:16px;line-height:16px;top:-6px;right:-6px";
    node.classList.add("input-image");
    node.insertAdjacentHTML('beforeend', '<icon class="picture-delete" style="'+commonStyle+'">'+Icons.ic_close+'</icon>');
    node.insertAdjacentHTML('beforeend', '<icon class="picture-reset"  style="'+commonStyle+'">'+Icons.ic_repeat+'</icon>');

    const icon = node.querySelector('icon') as HTMLElement;
    const deleteTag = node.querySelector('.picture-delete') as HTMLElement;
    const resetTag = node.querySelector('.picture-reset') as HTMLElement;

    setPreview = function(value?: string){
      if(icon) icon.style.display = value === undefined ? '' : 'none';
      if(value){
        node.style.backgroundPosition = "50%";
        node.style.backgroundSize = "cover";
        node.style.backgroundImage = `url('${value}')`;
      }else{
        node.style.backgroundImage = 'unset';
      }
      if(deleteTag) deleteTag.style.display = value !== undefined ? '' : 'none';
      if(resetTag) resetTag.style.display = value === undefined && originalValue.length > 0 ? '' : 'none';
    }

    if(deleteTag) {
      deleteTag.addEventListener("click", function(e){
        e.stopPropagation();
        inputFile.customFiles = [];
        inputFile.dispatchEvent(new Event("change"));
      });
    }

    if(resetTag) {
      resetTag.addEventListener("click", function(e){
        e.stopPropagation();
        inputFile.customFiles = originalValue;
        inputFile.dispatchEvent(new Event("change"));
      });
    }
  }

  inputFile.addEventListener('change', async function(){
    const file = this.customFiles[0];
    if(!file){
      setPreview(undefined);
    }else if(file instanceof File){
      if(file.type.indexOf('image/')===0){
        const rect = node.getBoundingClientRect();
        setPreview(await Redim.thumbnail(file, {width:rect.width, height:rect.height}))
      }else{
        setPreview(getIconFromMimeType(file.type).toURL())
      }
    }else{
      //case it is a media
      if(file.mimeType.indexOf('image/')===0){
        setPreview(addParams(file.pictureUrl,{s:"c",w:512,h:512}))
      }else{
        setPreview(getIconFromMimeType(file.mimeType).toURL())
      }
    }
  })
  inputFile.dispatchEvent(new Event("change"));
}

function destroyDom(node: HTMLElement){
  actionMenu.destroyDom(node);
}
